import React from 'react'

export default function About() {
    return (
        <div className="bg-red-200 text-center w-screen h-screen mx-auto py-10 font-mono sm:overflow-hidden overflow-hidden  ">
            <h2 className="text-3xl text-purple-800 text-center ">Amazing Recipes</h2>
            <h4 className="text-2xl text-center p-3 ">Spice up your cooking with amazing meals from all over the world!</h4>
            <p className="text-lg p-5 ">Bacon ipsum dolor amet hamburger biltong corned beef doner turkey.
             Chicken short loin beef ribs, jerky shoulder short ribs prosciutto jowl turkey kielbasa turducken brisket drumstick ground round bresaola. 
             Pork loin ribeye ham pork, strip steak hamburger swine biltong frankfurter short ribs salami chuck filet mignon shank tail. Capicola t-bone pork chop rump. 
            Chicken pork belly turducken pork chop ball tip venison pastrami pork loin. 
            Sirloin short loin tail prosciutto kielbasa pig chicken landjaeger tenderloin brisket shoulder. 
            Pastrami ham hock short ribs jerky rump ground round boudin. Pork loin meatloaf cupim pork chop ham hock shoulder swine frankfurter. 
            Beef ribs doner ground round rump tenderloin chuck turducken pork chislic boudin. Ham hock meatloaf ground round biltong tail shoulder. 
            Biltong turkey meatball, cow capicola frankfurter kielbasa short loin tri-tip.</p>
        </div>
    )
}
